import create, { SetState } from 'zustand';

import SKUResponseDTO from './SKUResponseDTO';

export interface ISKUModalDTO {
  object?: SKUResponseDTO;
  type: 'count' | 'link';
}
export interface SKUModalState {
  skuModal: ISKUModalDTO;
  notify: boolean;
  view: number;
  setModal: (skuModal: ISKUModalDTO) => void;
  setView: (v: number) => void;
  closeModal: () => void;
  renewalNotice: boolean;
  setRenewalNotice: (b: boolean) => void;
}
export const useSKUModalStore = create<SKUModalState>((set: SetState<SKUModalState>) => ({
  skuModal: {
    object: {
      featureCode: '',
      type: '',
      countType: '',
      consumed: 0,
      balance: 0,
      actualLimit: 0,
      message: 'You have reached the limit of  0.  For more usage please contact sales.',
    },
    type: 'count',
  },
  notify: false,
  view: 0,
  renewalNotice: false,
  setModal: (notifyObject: ISKUModalDTO) => set({ skuModal: notifyObject, notify: true }),
  setView: (v: number) => set({ view: v }),
  closeModal: () => set({ notify: false, view: 0 }),
  setRenewalNotice: (b: boolean) => set({ renewalNotice: b }),
}));
